import angular from 'angular';
import linearThumb from './linearThumb';

export default angular
  .module('components.linearThumb', [])
  .component('linearThumb', linearThumb).name;
